import React, { useEffect, useRef, useState } from "react";

const WILLIE_IMG =
  "/images/t5r0bn7a_UNCLE_WILLIES.png";

export default function SplashScreen() {
  const standalone =
    typeof window !== "undefined" &&
    (window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true);

  const seen =
    typeof window !== "undefined" &&
    sessionStorage.getItem("uw_splash_seen") === "1";

  // Decide once, synchronously, whether to show — avoids flicker / StrictMode races.
  const [show, setShow] = useState(!(!standalone && seen));
  const [fade, setFade] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (!show || started.current) return;
    started.current = true;
    sessionStorage.setItem("uw_splash_seen", "1");
    document.body.style.overflow = "hidden";

    const t1 = setTimeout(() => setFade(true), 1900);
    const t2 = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
    }, 2500);
    // Note: intentionally not clearing these on cleanup — under StrictMode the
    // ref guard would otherwise leave no active timer after the remount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#16110E] transition-opacity ${
        fade ? "opacity-0" : "opacity-100"
      }`}
      style={{ transitionDuration: "560ms" }}
    >
      <img
        src={`${process.env.PUBLIC_URL || ""}/logo.png`}
        alt="Uncle Willie's Southern Bistro"
        className="h-20 w-auto mb-6 animate-[splashUp_0.7s_ease]"
      />

      <div className="relative animate-[splashPop_0.8s_cubic-bezier(0.16,1,0.3,1)]">
        <div className="w-52 h-52 md:w-64 md:h-64 rounded-full overflow-hidden ring-4 ring-[#E0971A]/70 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.85)]">
          <img
            src={WILLIE_IMG}
            alt="Uncle Willie welcomes you"
            className="w-full h-full object-cover object-top scale-105"
          />
        </div>
        <span className="absolute -inset-3 rounded-full border border-[#1493C4]/30 animate-ping" />
      </div>

      <p className="font-display italic text-2xl text-[#F3EAD7] mt-8">
        Uncle Willie welcomes you
      </p>
      <p className="label-mono text-[#7FB4C2] mt-2">
        Good Food · Good Friends · A Good Time
      </p>

      <div className="flex gap-1.5 mt-7">
        {[0, 1, 2].map((d) => (
          <span
            key={d}
            className="w-2 h-2 rounded-full bg-[#D5521B] animate-bounce"
            style={{ animationDelay: `${d * 0.15}s` }}
          />
        ))}
      </div>
    </div>
  );
}
